module.exports = __webpack_public_path__ + "img/my-male.19fc7b05.png";